import { functionalityConstants } from '../constants';
import { alertActions } from 'actions';
import { functionalityService } from 'services';
import { global } from 'config';

export const functionalityActions = {
  getAll
};

function getAll(limit = global.LIMIT, page = global.PAGE, filters) {
  return dispatch => {
    dispatch(request());

    functionalityService.getAll(limit, page, filters)
      .then(
        data => dispatch(success(data)),
      ).catch(error => {
        dispatch(failure(error));
        dispatch(alertActions.error(error.data || error.message));
      });;;
  };

  function request() { return { type: functionalityConstants.GET_FUNCTIONALITIES_REQUEST } }
  function success(data) { return { type: functionalityConstants.GET_FUNCTIONALITIES_SUCCESS, data } }
  function failure(error) { return { type: functionalityConstants.GET_FUNCTIONALITIES_FAILURE, error } }
}
